import type {
  ProjectPriority,
  ProjectPrivacy,
  ProjectStatus,
} from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'

export type UpdatePortfolioProject = {
  id: string
  title?: string
  description?: string
  portfolioColumnId?: string
  portfolioId?: string
  status?: string
  priority?: string
  startDate?: string | null
  endDate?: string | null
  privacy?: string
  horizontTagId?: string
  riscTagId?: string
}

export type UpdatePortfolioProjectResponse = {
  id: string
  title?: string
  description?: string
  portfolioColumnId?: string
  portfolioId?: string
  status?: ProjectStatus
  priority?: ProjectPriority
  startDate?: string | null
  endDate?: string | null
  privacy?: ProjectPrivacy
  createdAt?: string
  updatedAt?: string
}

export async function updatePortfolioProject({
  id,
  title,
  description,
  portfolioColumnId,
  portfolioId,
  status,
  priority,
  startDate,
  endDate,
  privacy,
  horizontTagId,
  riscTagId,
}: UpdatePortfolioProject): Promise<UpdatePortfolioProjectResponse> {
  const { data } = await httpClient.put<UpdatePortfolioProjectResponse>(
    `/projects/portfolio-projects/${id}`,
    {
      title,
      description,
      portfolioColumnId,
      portfolioId,
      status,
      priority,
      startDate,
      endDate,
      privacy,
      horizontTagId,
      riscTagId,
    },
  )

  return data
}
